<div class="radio-option-group" [class.radio-option-group--card]="variant() === 'card'">
  @if (groupLabel()) {
    <p class="radio-option-group__label">{{ groupLabel() }}</p>
  }
  <div
    class="radio-option-group__options"
    [class.radio-option-group__options--row]="direction() === 'row'"
    [class.radio-option-group__options--column]="direction() === 'column'">
    @for (opt of options(); track opt.value; let i = $index) {
      <label
        class="radio-option-group__option"
        [class.radio-option-group__option--disabled]="opt.disabled"
        [for]="getOptionId(opt, i)">
        @if (opt.disabled) {
          <input
            type="radio"
            [attr.name]="controlName()"
            [value]="opt.value"
            [id]="getOptionId(opt, i)"
            disabled
            tabindex="-1"
            aria-disabled="true" />
        } @else {
          <input
            type="radio"
            [formControlName]="controlName()"
            [attr.name]="controlName()"
            [value]="opt.value"
            [id]="getOptionId(opt, i)" />
        }
        @if (variant() === 'card') {
          <span class="radio-option-group__circle" aria-hidden="true"></span>
        }
        <span class="radio-option-group__text-block">
          <span class="radio-option-group__option-text">{{ opt.label }}</span>
          @if (opt.helperText) {
            <small class="radio-option-group__helper-text">{{ opt.helperText }}</small>
          }
        </span>
      </label>
    }
  </div>
  @if (invalid() && touched() && errorMessage()) {
    <div class="invalid-feedback d-block mt-2">{{ errorMessage() }}</div>
  }
</div>
